import React from "react";
import { 
  styled,
  Card,
  CardMedia,
  CardHeader,
  CardContent,
  CardActions,
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Box
} from "@mui/material";
import { grey } from "@mui/material/colors";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import MoreVertIcon from '@mui/icons-material/MoreVert';

function PhotoCard({ images }) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card 
      className="relative"
      sx={{ border: 0, boxShadow: 0, p: 1 }}
    >
      {/* CardHeader */}
      <CardHeader 
        className="absolute top-0 end-1"
        action={
          <IconButton
            sx={{ color: "white", ":hover": {} }} 
            aria-label="settings"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
        }
      />
      {/* Menu */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClick={handleClose}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClose}>
          <IconButton sx={{ ":hover": { bgcolor: grey[100] } }}>
            <DownloadIcon />
          </IconButton>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <IconButton sx={{ ":hover": { bgcolor: grey[100] } }}>
            <EditIcon />
          </IconButton>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <IconButton sx={{ ":hover": { bgcolor: grey[100] } }}>
            <DeleteIcon />
          </IconButton>
        </MenuItem>
      </Menu>
      {/* CardMedia */}
      <CardMedia
        component="img"
        image={images.image}
        sx={{ height: 300, objectFit: "cover", boxShadow: 2, borderRadius: 3 }}
      />
      
    </Card>
  );
}

export default PhotoCard;
